import {gql} from "apollo-angular";
import {baseResponse, baseResponseGraphqlField} from "../../../base.graphql";


export const directCostFields = `
id
costUniqueId
billingCost
billingDescription
`


export const CREATE_SERVICE_DIRECT_COST = gql`
  mutation CreateDirectCostScheme($input: DirectCostSchemeInputObjects!) {
    createDirectCostScheme(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${directCostFields}
      }
    }
  }
`


export const UPDATE_SERVICE_DIRECT_COST = gql`
  mutation UpdateDirectCostScheme($input: DirectCostSchemeInputObjects!) {
    updateDirectCostScheme(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${directCostFields}
      }
    }
  }
`

export const DELETE_SERVICE_DIRECT_COST = gql`
  mutation DeleteDirectCostScheme($costUniqueId: String!) {
    deleteDirectCostScheme(costUniqueId: $costUniqueId) {
      ${baseResponseGraphqlField}
    }
  }
`

export const GET_SERVICE_DIRECT_COST = gql`
  query GetInstitutionServiceDirectCostSchemes($billingUniqueId: String) {
    getInstitutionServiceDirectCostSchemes(billingUniqueId: $billingUniqueId) {
      ${baseResponseGraphqlField}
      data {
        ${directCostFields}
      }
    }
  }
`

export const CITIZEN_GET_INSTITUTION_SERVICE_DIRECT_COST_SCHEMES = gql`
  query CitizenGetInstitutionServiceDirectCostSchemes($billingUniqueId: String) {
    citizenGetInstitutionServiceDirectCostSchemes(billingUniqueId: $billingUniqueId) {
      response {
        ${baseResponse}
      }
      data {
        ${directCostFields}
      }
    }
  }
`;
